<div class="maintenance-container" id="maintenance-mode-container">
    <div class="header-image">
        <img src="assets/images/octopus-mini-icon.svg" alt="Playoctopus Icon" />
    </div>

    <div class="header-text">
        The Dashboard is Unavailable Due to Maintenance
    </div>

    <div class="content">
        <p>
            During this time, you will be unable to view your points, earnings,
            referrals and cash outs. We expect the dashboard to be available
            again by {{ maintenanceEndDate }}.
        </p>
        <p>
            Please note: this does not affect your tablet - your tablet should
            be working as normal and your points will still accumulate when you
            drive.
        </p>

        <p>
            If you are having issues with your tablet, please visit our &nbsp;
            <a href="https://playoctopus.com/new-drivers/help-center/"
                >Help Center</a
            >.
        </p>
    </div>
</div>
